<template>
  <div>
    <K2Text>{{ label }}</K2Text>
    <div class="d-block K2Input">
      <input v-on="listeners" :placeholder="placeholder" :value="value" />
      <!--      <el-input :placeholder="placeholder"-->
      <!--                v-model="vModel"-->
      <!--                type="textarea"-->
      <!--                :rows="rows"-->
      <!--                v-if="isTextArea"-->
      <!--      ></el-input>-->
      <!--      <el-input :placeholder="placeholder"-->
      <!--                v-model="vModel"-->
      <!--                v-else-->
      <!--      ></el-input>-->
    </div>
  </div>
</template>

<script>
import K2Text from '../k2Text/k2Text'

export default {
  name: 'K2Input',
  components: { K2Text },
  props: ['placeholder', 'value', 'onchange', 'label', 'name', 'vModel', 'isTextArea', 'rows'],
  data() {
    return {}
  },
  computed: {
    listeners() {
      return {
        input: this.updateValue,
        // focus: this.onFocus,
        // blur: this.onBlur,
      }
    },
  },
  created() {},
  methods: {
    updateValue(evt) {
      let value = evt.target.value
      // console.log(value,"onchange")
      this.$emit('onchange', value, this.name)
    },
  },
}
</script>
